import template from './devChangeEmployeeMobile.html';
import controller from './devChangeEmployeeMobile.controller';
import './devChangeEmployeeMobile.scss';

let devChangeEmployeeMobileComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default devChangeEmployeeMobileComponent;



// WEBPACK FOOTER //
// ./client/app/components/mainMenuMobile/devChangeEmployeeMobile/devChangeEmployeeMobile.component.js